const DOMAIN_NAME_TYPOS: Record<string, string> = {
  gmial: 'gmail',
  gmal: 'gmail',
  gma: 'gmail',
  gmai: 'gmail',
  gamil: 'gmail',
  gnail: 'gmail',
  gmaill: 'gmail',
  gmile: 'gmail',
  hotnail: 'hotmail',
  hotmal: 'hotmail',
  hotmial: 'hotmail',
  hotamil: 'hotmail',
  yahooo: 'yahoo',
  yaho: 'yahoo',
  yhoo: 'yahoo',
  yaoo: 'yahoo',
  outloo: 'outlook',
  outlok: 'outlook',
  outllook: 'outlook',
  iclod: 'icloud',
  icoud: 'icloud',
  protonmal: 'protonmail',
};

const DOMAIN_CANONICAL_TLD: Record<string, string> = {
  gmail: 'com',
  hotmail: 'com',
  yahoo: 'com',
  outlook: 'com',
  icloud: 'com',
  aol: 'com',
  protonmail: 'com',
  example: 'org',
};

export const getEmailDomainSuggestion = (email: string): string | undefined => {
  if (!email || typeof email !== 'string') {
    return undefined;
  }

  const atIndex = email.lastIndexOf('@');
  if (atIndex === -1) {
    return undefined;
  }

  const domain = email.slice(atIndex + 1).toLowerCase();
  const lastDotIndex = domain.lastIndexOf('.');
  const namePart = lastDotIndex === -1 ? domain : domain.slice(0, lastDotIndex);
  const correctedName = DOMAIN_NAME_TYPOS[namePart] ?? namePart;
  const canonicalTld = DOMAIN_CANONICAL_TLD[correctedName];

  if (!canonicalTld) {
    return undefined;
  }

  const correctedDomain = `${correctedName}.${canonicalTld}`;
  if (domain === correctedDomain) {
    return undefined;
  }

  return `${email.slice(0, atIndex + 1)}${correctedDomain}`;
};
